<script lang='ts'>
    // Bindings 
    export let journalists = [];
    export let width = 0;
    let copied = false;

    const phoneFormater = new Intl.ListFormat('no', { style: 'long', type: 'disjunction' });
    
    const viewNumber = (number, index, name) => {
        navigator.clipboard.writeText(number).then(() => {
            document.getElementById(`btn-${index}`).innerText = number
            copied = true;
			setTimeout(() => {
                document.getElementById(`btn-${index}`).innerText = name
                copied = false;		
			}, 5000);
		}
		);

    }
    
</script> 

{#if width > 500}
{#each journalists as journalist, i}
    <button id="btn-{i}" class="btn-link" on:click={()=>viewNumber(journalist.phone, i, journalist.name.split(' ')[0])}>{journalist.name.split(' ')[0]}</button>{(i < journalists.length-2) ? ', ' : (i == journalists.length-2) ? ' eller ' : '.'}
{/each}
{@html copied ? "<i>(kopiert)</i>" : ''}

{:else}
{@html phoneFormater.format(journalists.map(journalist => {
    return `<a href="tel:${journalist.phone}">${journalist.name.split(' ')[0]}</a>`
}))}
{/if}



<style lang='scss'>
    :global(a) {
        color: #000;
        text-decoration: underline;
        font-size: 16px;
    }
    :global(button.btn-link) {
        color: #000;
        text-decoration: underline;
        border: 0;
        padding: 0;
        margin: 0;
        cursor: pointer;
        background: none;
        font-size: 16px;
    }
</style>